import { Theme, useMediaQuery } from "@mui/material";
import { Breakpoint } from "@mui/material/styles";

export const useBreakpointQuery = (breakpoint: Breakpoint) =>
    useMediaQuery((theme: Theme) => theme.breakpoints.down(breakpoint));

export const useBreakpointQueryUpwards = (breakpoint: Breakpoint) =>
    useMediaQuery((theme: Theme) => theme.breakpoints.up(breakpoint));
